import React from 'react'

import clsx from 'clsx'

import GoodRecommendations from 'components/GoodRecommendations'
import Listing from 'components/Listing'
import { useEventContext } from 'context/EventContext'
import openUrl from 'helpers/openUrl'
import { revealSEOUrl } from 'helpers/SEOHelper'

import CompareSearchBar from './components/SearchBar'

import classes from './AddToCompare.module.scss'

/** @type {import("./types").default} */
const AddToCompare = ({ listings, alternatives }) => {
  const { addEvent } = useEventContext()

  return (
    <>
      <div className={clsx('AddToCompare', classes.addToCompareBox)}>
        <div className={classes.searchContainer}>
          <div className={clsx(classes.titleContainer)}>
            <p className={classes.title}>Add to Compare</p>
          </div>
          <div className={classes.searchBarContainer}>
            <CompareSearchBar listings={listings} placeholder="Type an app name" />
          </div>
        </div>
        <div className={classes.suggestionsSection}>
          <div>
            <div className={classes.compareSearch}>
              <p className={clsx(classes.title, classes.titleCompare)}>Compare similar apps</p>
            </div>
            <div className={classes.contentSection}>
              {alternatives.map(listing => (
                <Listing.MiniCard
                  {...addEvent({
                    engagementComponent: 'add-to-compare',
                    engagementDestination: 'compare_add-product',
                    engagementDetails: 'card_similar-product',
                    name: 'engagement_product_click',
                  })}
                  onClick={() => {
                    openUrl(revealSEOUrl(listing.add_to_compare_url), { target: '_self' })
                  }}
                  listing={listing}
                  key={`key-${listing.name}`}
                  data-testid="addtocompare-minicard"
                />
              ))}
            </div>
          </div>
        </div>
        <div className={classes.goodRecommendationsContainer}>
          <GoodRecommendations />
        </div>
      </div>
    </>
  )
}

export default AddToCompare
